import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Box, Group, Stack } from "@components/mantine";
import { forwardRef } from "react";
import { Locales } from "../../strings/Locales.js";
import { SourceIdentityCategoryIcon } from "./source-identity-category-icon/SourceIdentityCategoryIcon.js";
import { SourceIdentityTypeImage } from "./source-identity-type-image/SourceIdentityTypeImage.js";
import { SourceIdentityTypeLabel } from "./source-identity-type-label/SourceIdentityTypeLabel.js";
import { useSourceIdentityContext } from "./SourceIdentityContext.js";
var BADGE_COLOR_MAPPINGS = {
    BETA: Badge.Secondary,
    DEPRECATED: Badge.Warning,
    NEW: Badge.Secondary,
    RECOMMENDED: Badge.Primary
};
export var SourceIdentityCardVariant = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var _children = _param.children, _trackingHandler = _param.trackingHandler, props = _object_without_properties(_param, [
        "children",
        "trackingHandler"
    ]);
    var _$ref = useSourceIdentityContext(), badge = _$ref.badge, getStyles = _$ref.getStyles;
    var BadgeComponent = badge ? BADGE_COLOR_MAPPINGS[badge] : Badge.Secondary;
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref,
        flex: 1
    }, getStyles("root"), props), {
        children: /*#__PURE__*/ _jsxs(Group, {
            justify: "space-between",
            wrap: "nowrap",
            h: 40,
            children: [
                /*#__PURE__*/ _jsxs(Group, {
                    gap: "sm",
                    wrap: "nowrap",
                    children: [
                        /*#__PURE__*/ _jsx(SourceIdentityTypeImage, {
                            size: "xxl"
                        }),
                        /*#__PURE__*/ _jsxs(Stack, {
                            gap: 2,
                            children: [
                                badge && /*#__PURE__*/ _jsx(BadgeComponent, {
                                    children: Locales.format("SourceIdentity.Badge.".concat(badge))
                                }),
                                /*#__PURE__*/ _jsx(SourceIdentityTypeLabel, {
                                    size: "lg"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SourceIdentityCategoryIcon, {
                    size: "lg"
                })
            ]
        })
    }));
});
SourceIdentityCardVariant.displayName = "@resourceIdentity/source/SourceIdentity/CardVariant";

//# sourceMappingURL=SourceIdentityCardVariant.js.map